import type { ColumnPin } from "@common/types/views/views";
import { Button } from "@design-system/Button/Button";
import { Menu } from "@design-system/Menu/Menu.lib";
import { PinIcon, PinOpenIcon } from "@icons";

interface PinMenuProps {
    /** The column's name, for the trigger's accessible name. */
    name: string;
    isPinned?: ColumnPin;
    onPin: (pin: ColumnPin | undefined) => void;
}

/** The pin menu trigger's accessible name, which focus restores look up. */
export const getPinMenuLabel = (name: string) => `Pin ${name} column`;

/**
 * A column row's menu to pin the column to either end or unpin it. The
 * trigger shows an empty pin, or a filled one once the column is pinned.
 */
export const PinMenu = ({ name, isPinned, onPin }: PinMenuProps) => (
    <Menu.Root
        align="end"
        trigger={
            <Button
                variant="secondary"
                size="sm"
                iconOnly
                aria-label={getPinMenuLabel(name)}
            >
                {isPinned === undefined ? <PinOpenIcon /> : <PinIcon />}
            </Button>
        }
    >
        {isPinned !== "left" && (
            <Menu.Item onClick={() => onPin("left")}>Pin left</Menu.Item>
        )}
        {isPinned !== "right" && (
            <Menu.Item onClick={() => onPin("right")}>Pin right</Menu.Item>
        )}
        {isPinned !== undefined && (
            <Menu.Item onClick={() => onPin(undefined)}>Unpin</Menu.Item>
        )}
    </Menu.Root>
);
